export const VLAN_POOL_PROFILE_SECTION_EVENT =
	'canvas-agent:vlan-pool-profile:section';
export const VLAN_POOL_PROFILE_CREATE_MODAL_EVENT =
	'canvas-agent:vlan-pool-profile:create-modal';
export const VLAN_POOL_PROFILE_FILTER_EVENT =
	'canvas-agent:vlan-pool-profile:filter';
export const VLAN_POOL_PROFILE_FOCUS_EVENT =
	'canvas-agent:vlan-pool-profile:focus';
export const VLAN_POOL_PROFILE_EDIT_MODAL_EVENT =
	'canvas-agent:vlan-pool-profile:edit-modal';
export const VLAN_POOL_PROFILE_DELETE_MODAL_EVENT =
	'canvas-agent:vlan-pool-profile:delete-modal';
